import type { DocusignTemplate } from 'src/interfaces/docusignTemplate'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getDocusignTemplates = (state: State): DocusignTemplate[] => {
  return state.docusignTemplate.templates
}

export const getDocusignTemplatesLoading = (state: State): boolean => {
  return state.docusignTemplate.templatesLoading
}

export const getDocusignTemplatesError = (state: State): string | null => {
  return state.docusignTemplate.templatesError
}

export const getDocusignTemplateSaving = (state: State): boolean => {
  return state.docusignTemplate.saving
}

export const getDocusignTemplateDeletingId = (state: State): string | null => {
  return state.docusignTemplate.deletingId
}
